import { Pipe } from "@angular/core";

@Pipe({
    name: "BehindIDCardPipe"
})
export class BehindIDCardPipe {
    transform(rawNum: string) {
        console.log(rawNum);
        let BehindIdCardPipe = '';
        if (rawNum) {
            const firstStr = rawNum.slice(0, 2).toUpperCase();
            const firstSubStr = rawNum.slice(2, 3);
            const secondStr = rawNum.slice(3, 10);
            const thirdStr = rawNum.slice(10, 12);
            BehindIdCardPipe = `${firstStr}${firstSubStr}-${secondStr}-${thirdStr}`;
        }
        return BehindIdCardPipe
    }
}

